import React, { useState } from 'react';
import { resolveApiUrl } from '../api';

interface Diary {
  id: number;
  person_id: number;
  content: string;
  date: string;
  created_at: string;
  images?: DiaryImage[];
}

interface DiaryImage {
  id: number;
  url: string;
  created_at?: string;
}

interface DiaryItemProps {
  diary: Diary;
  onEdit: (diary: Diary) => void;
  onDelete: (diaryId: number) => void;
}

const DiaryItem: React.FC<DiaryItemProps> = ({ diary, onEdit, onDelete }) => {
  const [previewImageUrl, setPreviewImageUrl] = useState<string | null>(null);

  const formatDate = (dateString: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const diaryDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    
    // 计算日期差
    const diffTime = today.getTime() - diaryDate.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    
    let datePrefix = '';
    if (diffDays === 0) {
      datePrefix = '今天';
    } else if (diffDays === 1) {
      datePrefix = '昨天';
    } else if (diffDays === 2) {
      datePrefix = '前天';
    } else if (diffDays < 7) {
      datePrefix = `${diffDays}天前`;
    }
    
    const formattedDate = date.toLocaleString('zh-CN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
    
    return datePrefix ? `${datePrefix} ${formattedDate}` : formattedDate;
  };

  const wordCount = diary.content.trim().length;

  return (
    <div className="diary-item">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <div className="date">
          📅 {formatDate(diary.date || diary.created_at)}
        </div>
        <span style={{ fontSize: '12px', color: '#999' }}>
          {wordCount} 字
        </span>
      </div>
      <div className="content">{diary.content}</div>

      {Array.isArray(diary.images) && diary.images.length > 0 && (
        <div style={{ marginTop: 10, display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 6 }}>
          {diary.images.slice(0, 9).map(img => {
            const url = resolveApiUrl(img.url);
            return (
              <button
                key={img.id}
                type="button"
                onClick={() => setPreviewImageUrl(url)}
                style={{ padding: 0, border: 'none', background: 'none', cursor: 'pointer', borderRadius: 10, overflow: 'hidden' }}
              >
                <img
                  src={url}
                  alt="diary"
                  style={{ width: '100%', height: 84, objectFit: 'cover', borderRadius: 10, border: '1px solid #f0f0f0', display: 'block' }}
                />
              </button>
            );
          })}
        </div>
      )}

      {previewImageUrl && (
        <div
          role="dialog"
          aria-modal="true"
          aria-label="图片预览"
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            background: 'rgba(0,0,0,0.88)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 20,
          }}
          onClick={() => setPreviewImageUrl(null)}
        >
          <img
            src={previewImageUrl}
            alt="预览"
            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      <div style={{ marginTop: '15px', display: 'flex', gap: '10px', paddingTop: '15px', borderTop: '1px solid #f0f0f0' }}>
        <button
          className="btn btn-secondary"
          style={{ fontSize: '12px', padding: '6px 12px' }}
          onClick={() => onEdit(diary)}
        >
          ✏️ 编辑
        </button>
        <button
          className="btn btn-danger"
          style={{ fontSize: '12px', padding: '6px 12px' }}
          onClick={() => onDelete(diary.id)}
        >
          🗑️ 删除
        </button>
      </div>
    </div>
  );
};

export default DiaryItem;



